export default __webpack_public_path__ + "static/media/polk_slide_bg.06d00078.jpg";